import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-54ec15c5"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "report-section property-details" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("legend", null, "Property Address", -1))
const _hoisted_3 = { class: "form-group row" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "col-sm-2 col-form-label" }, [
  /*#__PURE__*/_createTextVNode("Address "),
  /*#__PURE__*/_createElementVNode("span", { class: "sr-only" }, "Line 1")
], -1))
const _hoisted_5 = { class: "col-sm-6" }
const _hoisted_6 = { class: "form-group row" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "col-sm-2 col-form-label" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "sr-only" }, "Address Line 2")
], -1))
const _hoisted_8 = { class: "col-sm-6" }
const _hoisted_9 = { class: "form-group row" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "col-sm-2 col-form-label" }, "City", -1))
const _hoisted_11 = { class: "col-sm-2" }
const _hoisted_12 = { class: "form-group row" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "col-sm-2 col-form-label" }, "County", -1))
const _hoisted_14 = { class: "col-sm-2" }
const _hoisted_15 = { class: "form-group row" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "col-sm-2 col-form-label" }, "Postcode", -1))
const _hoisted_17 = { class: "col-sm-2" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("legend", null, "General Info", -1))
const _hoisted_19 = {
  key: 0,
  class: "form-group row"
}
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "col-sm-2 col-form-label" }, "Furnished", -1))
const _hoisted_21 = { class: "col-sm-4" }
const _hoisted_22 = {
  key: 1,
  class: "form-group row"
}
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "col-sm-2 col-form-label" }, "Check In report date and cleaning status at the beginning of tenancy", -1))
const _hoisted_24 = { class: "col-sm-9" }
const _hoisted_25 = { class: "form-group row" }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "col-sm-2 col-form-label" }, "Internal Notes for QC", -1))
const _hoisted_27 = { class: "col-sm-9" }
const _hoisted_28 = { class: "form-group row" }
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "col-sm-2 col-form-label" }, "General notes", -1))
const _hoisted_30 = { class: "col-sm-9" }
const _hoisted_31 = {
  key: 2,
  class: "form-group row"
}
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "col-sm-2 col-form-label" }, "Tenancy start date", -1))
const _hoisted_33 = { class: "col-sm-2" }
const _hoisted_34 = { key: 0 }
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("legend", null, "Parking", -1))
const _hoisted_36 = { class: "form-group row" }
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "col-sm-2 col-form-label" }, "Garage/Parking location", -1))
const _hoisted_38 = { class: "col-sm-6" }
const _hoisted_39 = { class: "form-group row" }
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "col-sm-2 col-form-label" }, "Parking space number", -1))
const _hoisted_41 = { class: "col-sm-2" }
const _hoisted_42 = { key: 1 }
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("legend", null, "Water", -1))
const _hoisted_44 = { class: "form-group row" }
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "col-sm-2 col-form-label" }, "Stopcock location", -1))
const _hoisted_46 = { class: "col-sm-6" }
const _hoisted_47 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("legend", null, "Photos", -1))
const _hoisted_48 = { class: "form-group row" }
const _hoisted_49 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "col-sm-2 col-form-label" }, "Property exterior", -1))
const _hoisted_50 = { class: "col-sm-8" }
const _hoisted_51 = { class: "row" }
const _hoisted_52 = {
  key: 0,
  class: "form-group row"
}
const _hoisted_53 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "col-sm-2 col-form-label" }, "Cleaning receipt", -1))
const _hoisted_54 = { class: "col-sm-8" }
const _hoisted_55 = { class: "row" }
const _hoisted_56 = { key: 2 }
const _hoisted_57 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("legend", null, "Forwarding Address", -1))
const _hoisted_58 = { class: "form-group row" }
const _hoisted_59 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "col-sm-2 col-form-label" }, "Name", -1))
const _hoisted_60 = { class: "col-sm-6" }
const _hoisted_61 = { class: "form-group row" }
const _hoisted_62 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "col-sm-2 col-form-label" }, [
  /*#__PURE__*/_createTextVNode("Address "),
  /*#__PURE__*/_createElementVNode("span", { class: "sr-only" }, "Line 1")
], -1))
const _hoisted_63 = { class: "col-sm-6" }
const _hoisted_64 = { class: "form-group row" }
const _hoisted_65 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "col-sm-2 col-form-label" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "sr-only" }, "Address Line 2")
], -1))
const _hoisted_66 = { class: "col-sm-6" }
const _hoisted_67 = { class: "form-group row" }
const _hoisted_68 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "col-sm-2 col-form-label" }, "City", -1))
const _hoisted_69 = { class: "col-sm-2" }
const _hoisted_70 = { class: "form-group row" }
const _hoisted_71 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "col-sm-2 col-form-label" }, "County", -1))
const _hoisted_72 = { class: "col-sm-2" }
const _hoisted_73 = { class: "form-group row" }
const _hoisted_74 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "col-sm-2 col-form-label" }, "Postcode", -1))
const _hoisted_75 = { class: "col-sm-2" }
const _hoisted_76 = { class: "form-group row" }
const _hoisted_77 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "col-sm-2 col-form-label" }, "Telephone", -1))
const _hoisted_78 = { class: "col-sm-2" }
const _hoisted_79 = { class: "form-group row" }
const _hoisted_80 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "col-sm-2 col-form-label" }, "Email", -1))
const _hoisted_81 = { class: "col-sm-6" }

import _get from "lodash/get";
import { computed, inject } from 'vue';
import { useStore } from 'vuex';
import Photos from "@/components/photo/Photos.vue";
import { Report } from "@/models";
import { DxDateBox } from "devextreme-vue/date-box";

export default /*#__PURE__*/_defineComponent({
  __name: 'PropertyDetails',
  setup(__props) {

const store = useStore();
const statereport = computed(() => store.getters['reports/current']);

const setReportDeep = (payload: { path: string; data: any }): Promise<any> => {
  return store.dispatch('reports/setReportDeep', payload);
};
const isDataentry = computed(() => store.getters['auth/isDataentry']);

const actProperty: any = inject('actProperty');

const addressLine1 = computed({
  get: () => statereport.value.address.line1,
  set: (data) => setReportDeep({ path: 'address.line1', data })
});

const addressLine2 = computed({
  get: () => statereport.value.address.line2,
  set: (data) => setReportDeep({ path: 'address.line2', data })
});

const addressTown = computed({
  get: () => statereport.value.address.town,
  set: (data) => setReportDeep({ path: 'address.town', data })
});

// Computed property for addressCounty
const addressCounty = computed({
  get: () => statereport.value.address.county,
  set: (data) => setReportDeep({ path: 'address.county', data })
});

// Computed property for addressPostcode
const addressPostcode = computed({
  get: () => statereport.value.address.postcode,
  set: (data) => setReportDeep({ path: 'address.postcode', data })
});

// Computed property for furnished
const furnished = computed({
  get: () => statereport.value.propertyDetails.furnished,
  set: (data) => setReportDeep({ path: 'propertyDetails.furnished', data })
});

// Computed property for InternalNotesForQC
const InternalNotesForQC = computed({
  get: () => statereport.value.propertyDetails.notes,
  set: (data) => setReportDeep({ path: 'propertyDetails.notes', data })
});

// Computed property for generalNotes
const generalNotes = computed({
  get: () => statereport.value.propertyDetails.generalNotes,
  set: (data) => setReportDeep({ path: 'propertyDetails.generalNotes', data })
});
// Computed property for historical_cleaning_status
const historicalCleaningStatus = computed({
  get: () => statereport.value.propertyDetails.historicalCleaningStatus,
  set: (data) => setReportDeep({ path: 'propertyDetails.historicalCleaningStatus', data })
});

// Computed property for locationPhotos
const locationPhotos = computed({
  get: () => statereport.value.propertyDetails.locationPhotos,
  set: (data) => setReportDeep({ path: 'propertyDetails.locationPhotos', data })
});

// Computed property for locationPhotos
const tenancyStartDate = computed({
  get: () => statereport.value.propertyDetails.tenancystartdate ?? null,
  set: (data) => setReportDeep({ path: 'propertyDetails.tenancystartdate', data })
});

// Computed property for cleaningReceiptPhotos
const cleaningReceiptPhotos = computed({
  get: () => statereport.value.propertyDetails.cleaningReceiptPhotos,
  set: (data) => setReportDeep({ path: 'propertyDetails.cleaningReceiptPhotos', data })
});

// Computed property for parkingLocation
const parkingLocation = computed({
  get: () => statereport.value.propertyDetails.parkingLocation,
  set: (data) => setReportDeep({ path: 'propertyDetails.parkingLocation', data })
});

// Computed property for parkingSpaceNo
const parkingSpaceNo = computed({
  get: () => statereport.value.propertyDetails.parkingSpaceNo,
  set: (data) => setReportDeep({ path: 'propertyDetails.parkingSpaceNo', data })
});

// Computed property for stopcockLocation
const stopcockLocation = computed({
  get: () => statereport.value.propertyDetails.stopcockLocation,
  set: (data) => setReportDeep({ path: 'propertyDetails.stopcockLocation', data })
});

// Computed property for forwardingContactName
const forwardingContactName = computed({
  get: () => statereport.value.propertyDetails.forwardingContact.name,
  set: (data: string) => setReportDeep({ path: 'propertyDetails.forwardingContact.name', data })
});

// Computed property for forwardingContactAddressLine1
const forwardingContactAddressLine1 = computed({
  get: () => statereport.value.propertyDetails.forwardingContact.address.line1,
  set: (data: string) => setReportDeep({ path: 'propertyDetails.forwardingContact.address.line1', data })
});

// Computed property for forwardingContactAddressLine2
const forwardingContactAddressLine2 = computed({
  get: () => statereport.value.propertyDetails.forwardingContact.address.line2,
  set: (data: string) => setReportDeep({ path: 'propertyDetails.forwardingContact.address.line2', data })
});

// Computed property for forwardingContactAddressTown
const forwardingContactAddressTown = computed({
  get: () => statereport.value.propertyDetails.forwardingContact.address.town,
  set: (data: string) => setReportDeep({ path: 'propertyDetails.forwardingContact.address.town', data })
});

// Computed property for forwardingContactAddressCounty
const forwardingContactAddressCounty = computed({
  get: () => statereport.value.propertyDetails.forwardingContact.address.county,
  set: (data: string) => setReportDeep({ path: 'propertyDetails.forwardingContact.address.county', data })
});

// Computed property for forwardingContactAddressPostcode
const forwardingContactAddressPostcode = computed({
  get: () => statereport.value.propertyDetails.forwardingContact.address.postcode,
  set: (data: string) => setReportDeep({ path: 'propertyDetails.forwardingContact.address.postcode', data })
});

// Computed property for forwardingContactPhone
const forwardingContactPhone = computed({
  get: () => statereport.value.propertyDetails.forwardingContact.phone,
  set: (data: string) => setReportDeep({ path: 'propertyDetails.forwardingContact.phone', data })
});

// Computed property for forwardingContactEmail
const forwardingContactEmail = computed({
  get: () => statereport.value.propertyDetails.forwardingContact.email,
  set: (data: string) => setReportDeep({ path: 'propertyDetails.forwardingContact.email', data })
});

/**
 * Returns Active Item Path
 */
const getGeneralCommentsPhotoPath = (report: Report) => {
  let path = `tenantcomments.tenantPhotos`;
  return path;
}

/**
 * Return Check-In Photos from Items
 *
 * @param {Item} item
 */
const getGeneralCommentsPhotos = (report: Report) => {
  let photos = _get(report, "tenantcomments.tenantPhotos", []);
  return photos;
}

const furnishedOptions: string[] = [
  "Unfurnished",
  "Part furnished",
  "Fully furnished",
  "Fully furnished with linen",
];


return (_ctx: any,_cache: any) => {
  const _component_multiselect_text = _resolveComponent("multiselect-text")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("fieldset", null, [
      _hoisted_2,
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("div", _hoisted_5, [
          _withDirectives(_createElementVNode("input", {
            type: "text",
            class: "form-control",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((addressLine1).value = $event))
          }, null, 512), [
            [
              _vModelText,
              addressLine1.value,
              void 0,
              { lazy: true }
            ]
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_6, [
        _hoisted_7,
        _createElementVNode("div", _hoisted_8, [
          _withDirectives(_createElementVNode("input", {
            type: "text",
            class: "form-control",
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((addressLine2).value = $event))
          }, null, 512), [
            [
              _vModelText,
              addressLine2.value,
              void 0,
              { lazy: true }
            ]
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_9, [
        _hoisted_10,
        _createElementVNode("div", _hoisted_11, [
          _withDirectives(_createElementVNode("input", {
            type: "text",
            class: "form-control",
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((addressTown).value = $event))
          }, null, 512), [
            [
              _vModelText,
              addressTown.value,
              void 0,
              { lazy: true }
            ]
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_12, [
        _hoisted_13,
        _createElementVNode("div", _hoisted_14, [
          _withDirectives(_createElementVNode("input", {
            type: "text",
            class: "form-control",
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((addressCounty).value = $event))
          }, null, 512), [
            [
              _vModelText,
              addressCounty.value,
              void 0,
              { lazy: true }
            ]
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_15, [
        _hoisted_16,
        _createElementVNode("div", _hoisted_17, [
          _withDirectives(_createElementVNode("input", {
            type: "text",
            class: "form-control",
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((addressPostcode).value = $event))
          }, null, 512), [
            [
              _vModelText,
              addressPostcode.value,
              void 0,
              { lazy: true }
            ]
          ])
        ])
      ])
    ]),
    _createElementVNode("fieldset", null, [
      _hoisted_18,
      (!_unref(actProperty).isFactoryreport(statereport.value.type))
        ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
            _hoisted_20,
            _createElementVNode("div", _hoisted_21, [
              _createVNode(_component_multiselect_text, {
                modelValue: furnished.value,
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((furnished).value = $event)),
                value: furnished.value,
                options: furnishedOptions
              }, null, 8, ["modelValue", "value"])
            ])
          ]))
        : _createCommentVNode("", true),
      (statereport.value.type === 'checkout')
        ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
            _hoisted_23,
            _createElementVNode("div", _hoisted_24, [
              _withDirectives(_createElementVNode("textarea", {
                class: "form-control",
                rows: "5",
                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((historicalCleaningStatus).value = $event))
              }, null, 512), [
                [
                  _vModelText,
                  historicalCleaningStatus.value,
                  void 0,
                  { lazy: true }
                ]
              ])
            ])
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_25, [
        _hoisted_26,
        _createElementVNode("div", _hoisted_27, [
          _withDirectives(_createElementVNode("input", {
            type: "text",
            class: "form-control",
            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((InternalNotesForQC).value = $event))
          }, null, 512), [
            [
              _vModelText,
              InternalNotesForQC.value,
              void 0,
              { lazy: true }
            ]
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_28, [
        _hoisted_29,
        _createElementVNode("div", _hoisted_30, [
          _withDirectives(_createElementVNode("textarea", {
            class: "form-control",
            rows: "20",
            "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((generalNotes).value = $event))
          }, null, 512), [
            [
              _vModelText,
              generalNotes.value,
              void 0,
              { lazy: true }
            ]
          ])
        ])
      ]),
      (isDataentry.value && statereport.value.type === 'inventory')
        ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
            _hoisted_32,
            _createElementVNode("div", _hoisted_33, [
              _createVNode(_unref(DxDateBox), {
                modelValue: tenancyStartDate.value,
                "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((tenancyStartDate).value = $event)),
                "display-format": "dd/MM/yyyy",
                type: "date",
                "picker-type": "calendar",
                calendarOptions: { firstDayOfWeek: 1 },
                "apply-value-mode": "instantly"
              }, null, 8, ["modelValue"])
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    (!_unref(actProperty).isFactoryreport(statereport.value.type))
      ? (_openBlock(), _createElementBlock("fieldset", _hoisted_34, [
          _hoisted_35,
          _createElementVNode("div", _hoisted_36, [
            _hoisted_37,
            _createElementVNode("div", _hoisted_38, [
              _withDirectives(_createElementVNode("input", {
                type: "text",
                class: "form-control",
                "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((parkingLocation).value = $event))
              }, null, 512), [
                [
                  _vModelText,
                  parkingLocation.value,
                  void 0,
                  { lazy: true }
                ]
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_39, [
            _hoisted_40,
            _createElementVNode("div", _hoisted_41, [
              _withDirectives(_createElementVNode("input", {
                type: "text",
                class: "form-control",
                "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((parkingSpaceNo).value = $event))
              }, null, 512), [
                [
                  _vModelText,
                  parkingSpaceNo.value,
                  void 0,
                  { lazy: true }
                ]
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (!_unref(actProperty).isFactoryreport(statereport.value.type))
      ? (_openBlock(), _createElementBlock("fieldset", _hoisted_42, [
          _hoisted_43,
          _createElementVNode("div", _hoisted_44, [
            _hoisted_45,
            _createElementVNode("div", _hoisted_46, [
              _withDirectives(_createElementVNode("input", {
                type: "text",
                class: "form-control",
                "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((stopcockLocation).value = $event))
              }, null, 512), [
                [
                  _vModelText,
                  stopcockLocation.value,
                  void 0,
                  { lazy: true }
                ]
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("fieldset", null, [
      _hoisted_47,
      _createElementVNode("div", _hoisted_48, [
        _hoisted_49,
        _createElementVNode("div", _hoisted_50, [
          _createElementVNode("div", _hoisted_51, [
            (_openBlock(), _createBlock(Photos, {
              key: `${locationPhotos.value.length}`,
              photos: locationPhotos.value,
              path: 'propertyDetails.locationPhotos'
            }, null, 8, ["photos", "path"]))
          ])
        ])
      ]),
      (!_unref(actProperty).isFactoryreport(statereport.value.type))
        ? (_openBlock(), _createElementBlock("div", _hoisted_52, [
            _hoisted_53,
            _createElementVNode("div", _hoisted_54, [
              _createElementVNode("div", _hoisted_55, [
                (_openBlock(), _createBlock(Photos, {
                  key: `${cleaningReceiptPhotos.value.length}`,
                  photos: cleaningReceiptPhotos.value,
                  path: 'propertyDetails.cleaningReceiptPhotos'
                }, null, 8, ["photos", "path"]))
              ])
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    (statereport.value.type === 'checkout')
      ? (_openBlock(), _createElementBlock("fieldset", _hoisted_56, [
          _hoisted_57,
          _createElementVNode("div", _hoisted_58, [
            _hoisted_59,
            _createElementVNode("div", _hoisted_60, [
              _withDirectives(_createElementVNode("input", {
                type: "text",
                class: "form-control",
                "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((forwardingContactName).value = $event))
              }, null, 512), [
                [
                  _vModelText,
                  forwardingContactName.value,
                  void 0,
                  { lazy: true }
                ]
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_61, [
            _hoisted_62,
            _createElementVNode("div", _hoisted_63, [
              _withDirectives(_createElementVNode("input", {
                type: "text",
                class: "form-control",
                "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((forwardingContactAddressLine1).value = $event))
              }, null, 512), [
                [
                  _vModelText,
                  forwardingContactAddressLine1.value,
                  void 0,
                  { lazy: true }
                ]
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_64, [
            _hoisted_65,
            _createElementVNode("div", _hoisted_66, [
              _withDirectives(_createElementVNode("input", {
                type: "text",
                class: "form-control",
                "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((forwardingContactAddressLine2).value = $event))
              }, null, 512), [
                [
                  _vModelText,
                  forwardingContactAddressLine2.value,
                  void 0,
                  { lazy: true }
                ]
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_67, [
            _hoisted_68,
            _createElementVNode("div", _hoisted_69, [
              _withDirectives(_createElementVNode("input", {
                type: "text",
                class: "form-control",
                "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((forwardingContactAddressTown).value = $event))
              }, null, 512), [
                [
                  _vModelText,
                  forwardingContactAddressTown.value,
                  void 0,
                  { lazy: true }
                ]
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_70, [
            _hoisted_71,
            _createElementVNode("div", _hoisted_72, [
              _withDirectives(_createElementVNode("input", {
                type: "text",
                class: "form-control",
                "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((forwardingContactAddressCounty).value = $event))
              }, null, 512), [
                [
                  _vModelText,
                  forwardingContactAddressCounty.value,
                  void 0,
                  { lazy: true }
                ]
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_73, [
            _hoisted_74,
            _createElementVNode("div", _hoisted_75, [
              _withDirectives(_createElementVNode("input", {
                type: "text",
                class: "form-control",
                "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((forwardingContactAddressPostcode).value = $event))
              }, null, 512), [
                [
                  _vModelText,
                  forwardingContactAddressPostcode.value,
                  void 0,
                  { lazy: true }
                ]
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_76, [
            _hoisted_77,
            _createElementVNode("div", _hoisted_78, [
              _withDirectives(_createElementVNode("input", {
                type: "tel",
                class: "form-control",
                "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((forwardingContactPhone).value = $event))
              }, null, 512), [
                [
                  _vModelText,
                  forwardingContactPhone.value,
                  void 0,
                  { lazy: true }
                ]
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_79, [
            _hoisted_80,
            _createElementVNode("div", _hoisted_81, [
              _withDirectives(_createElementVNode("input", {
                type: "email",
                class: "form-control",
                "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((forwardingContactEmail).value = $event))
              }, null, 512), [
                [
                  _vModelText,
                  forwardingContactEmail.value,
                  void 0,
                  { lazy: true }
                ]
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})